import { useCallback, useState } from "react";
import { API_URL_MAIN } from "../constants/driveglobalfilterinitalstates";

const TOKEN_URL = API_URL_MAIN + "jupiter_dic/get_token_digital_cluster";
const VEHICLE_STATE_URL = process.env.REACT_APP_CVP_VEHICLE_STATE_URL;

/* Fetches an access token from our own Node API (proxying Keycloak
   server-side to avoid CORS/secret exposure), then calls the CVP
   get-vehicle-state-details-for-dic API directly for a single VIN. */
const useVehicleStateDIC = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchVehicleState = useCallback(async (vin, applyData) => {
        setIsLoading(true);
        setError(null);
        try {
            let sessionToken = "";
            if (sessionStorage.getItem("user")) {
                sessionToken = JSON.parse(sessionStorage.user).token;
            }

            const tokenRes = await fetch(TOKEN_URL, {
                method: "POST",
                headers: {
                    "Content-type": "application/json; charset=UTF-8",
                    "x-auth-token": sessionToken,
                },
            });

            if (!tokenRes.ok) {
                throw new Error("Failed to fetch access token");
            }

            const tokenData = await tokenRes.json();
            const accessToken = tokenData?.data?.access_token;

            const stateRes = await fetch(VEHICLE_STATE_URL, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${accessToken}`,
                },
                body: JSON.stringify({ cv_ev_vins: [vin] }),
            });

            if (!stateRes.ok) {
                throw new Error("Failed to fetch vehicle state");
            }

            const result = await stateRes.json();
            applyData(result?.result);
        } catch (err) {
            setError(err.message || "Something Failed");
        }
        setIsLoading(false);
    }, []);

    return { isLoading, error, fetchVehicleState };
};

export default useVehicleStateDIC;
